export default __webpack_public_path__ + "static/media/box4.55f4cc92.svg";